import React, { useState } from 'react';

import Tippy from '@tippyjs/react';
import 'tippy.js/dist/tippy.css';
import 'tippy.js/animations/scale.css';
import { Button, ButtonProps, Text } from '@chakra-ui/react';
import styled from '../../../consts/styled';

const StyledButton = styled(Button)`
  justify-content: space-between;
  flex-wrap: nowrap;

  span {
    cursor: pointer;
    font-weight: 700;
    // color: #fff;
    margin: 0 8px;
  }

  span:first-child {
    margin-left: 16px;
  }

  span:hover {
    text-decoration: underline;
  }

  &.disabled {
    background: gray;
    opacity: 0.7;
    cursor: default;

    span:hover {
      text-decoration: none;
      cursor: default;
    }
  }
`;

interface ConfirmButtonProps extends ButtonProps {
  title?: string;
  message?: string;
  confirmMessage?: string;
  confirmText?: string;
  cancelText?: string;
  tippyContent?: string;

  colorScheme?: string;
  textColor?: string;

  enabled?: boolean;
  style?: Record<string, any>;
  className?: string;

  onConfirm?: () => void;
  onCancel?: () => void;
}

export const ConfirmBtn: React.FC<ConfirmButtonProps> = (props) => {
  const {
    children,
    message = 'Are You Sure?',
    confirmText = 'Confirm',
    cancelText = 'Cancel',
    tippyContent,
    colorScheme = 'blue',
    onConfirm = () => {},
    onCancel = () => {},
    enabled = true,
    style = {},
    className,
    textColor,
    isDisabled,
  } = props;

  const [confirm, setConfirm] = useState(false);

  if (tippyContent) {
    return (
      <Tippy
        arrow={true}
        theme="light"
        animation="scale"
        delay={800}
        content={tippyContent}
      >
        <StyledButton
          data-cy-unshare
          type={'button'}
          variant="outline"
          colorScheme={colorScheme}
          style={{
            ...style,
            cursor: enabled ? (confirm ? 'default' : 'pointer') : 'not-allowed',
          }}
          isDisabled={isDisabled}
          onClick={() => enabled && !confirm && setConfirm(true)}
          {...props}
        >
          {confirm ? (
            <Text as="div" textStyle="bodyXSmall" color={textColor}>
              {message}
              <span
                onClick={() => {
                  setConfirm(false);
                  onCancel();
                }}
                className={'text small unshare'}
              >
                {cancelText}
              </span>

              <span
                onClick={() => {
                  setConfirm(false);
                  onConfirm();
                }}
                className={'text small unshare'}
              >
                {confirmText}
              </span>
            </Text>
          ) : (
            children
          )}
        </StyledButton>
      </Tippy>
    );
  }

  return (
    <StyledButton
      data-cy-unshare
      type={'button'}
      variant="outline"
      colorScheme={colorScheme}
      style={{
        ...style,
        cursor: enabled ? (confirm ? 'default' : 'pointer') : 'not-allowed',
      }}
      onClick={() => enabled && !confirm && setConfirm(true)}
      {...props}
    >
      {confirm ? (
        <Text as="div" textStyle="bodyXSmall" color={textColor}>
          {message}
          <span
            onClick={() => {
              setConfirm(false);
              onCancel();
            }}
            className={'text small unshare'}
          >
            {cancelText}
          </span>

          <span
            onClick={() => {
              setConfirm(false);
              onConfirm();
            }}
            className={'text small unshare'}
          >
            {confirmText}
          </span>
        </Text>
      ) : (
        children
      )}
    </StyledButton>
  );
};
